<script lang="ts" setup>
import { useI18n } from 'vue-i18n'
import { CheckIcon, Users01Icon } from 'front-library'
import { ProcessedPayrollCard } from '@/app/core/services/payment-slips-export'

withDefaults(
  defineProps<{
    payroll: ProcessedPayrollCard
    selected: boolean
  }>(),
  {
    selected: false
  }
)

const emit = defineEmits(['select'])

const { t } = useI18n()
</script>
<template>
  <div
    class="rounded-xl border p-4 cursor-pointer transition-colors"
    :class="
      selected
        ? 'border-blue-500 bg-blue-50/60 ring-1 ring-blue-500'
        : 'border-gray-200 bg-white hover:border-gray-300'
    "
    @click="emit('select', payroll.id)">
    <div class="flex items-start gap-3">
      <!-- Radio -->
      <span
        class="mt-0.5 flex items-center justify-center w-5 h-5 rounded-full border transition-colors shrink-0"
        :class="
          selected ? 'bg-blue-600 border-blue-600' : 'border-gray-300 bg-white'
        ">
        <CheckIcon v-if="selected" class="w-3.5 h-3.5 text-white" />
      </span>
      <div class="flex-1 min-w-0">
        <!-- Titulo + badge -->
        <div class="flex items-center gap-2 flex-wrap">
          <h4
            class="text-base font-semibold"
            :class="selected ? 'text-gray-900' : 'text-gray-400'">
            {{ payroll.name }}
          </h4>
          <span
            v-if="payroll.isMostRecent"
            class="text-xs font-medium text-blue-600 bg-blue-100 rounded-md px-2 py-0.5">
            {{ t('paymentSlipsExport.processedPayrolls.mostRecent') }}
          </span>
        </div>
        <!-- Subtitulo: rango de fechas real de la nomina -->
        <p
          v-if="payroll.period"
          class="text-xs mt-0.5"
          :class="selected ? 'text-gray-500' : 'text-gray-400'">
          {{ payroll.period }}
        </p>
        <!-- Meta -->
        <div
          class="flex items-center gap-3 mt-2 text-sm flex-wrap"
          :class="selected ? 'text-gray-500' : 'text-gray-400'">
          <span class="flex items-center gap-1.5">
            <Users01Icon class="w-4 h-4" />
            {{
              t('paymentSlipsExport.processedPayrolls.employees', {
                count: payroll.employeesCount
              })
            }}
          </span>
          <!-- Badge fecha de cierre -->
          <span
            class="text-xs font-medium text-gray-600 bg-gray-100 rounded-md px-2 py-0.5">
            {{
              t('paymentSlipsExport.processedPayrolls.closedOn', {
                date: payroll.date
              })
            }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>
